import React, { useEffect, useState } from 'react';
import { Clock3Icon } from 'lucide-react';
const INITIAL_SECONDS = 17 * 60 + 33;
function parts(totalSeconds: number) {
  return [Math.floor(totalSeconds / 3600), Math.floor(totalSeconds % 3600 / 60), totalSeconds % 60].map(value => String(value).padStart(2, '0'));
}
export function Countdown() {
  const [seconds, setSeconds] = useState(INITIAL_SECONDS);
  const [hours, minutes, secs] = parts(seconds);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setSeconds(current => current <= 0 ? INITIAL_SECONDS : current - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <section aria-label="Tiempo restante de la oferta" className="mx-auto mt-8 max-w-md border border-[#b77b25] bg-[#111a2a] px-5 py-4 shadow-lg" data-id="element-1">
      <div className="mb-3 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.15em] text-[#f2c86f]" data-id="element-2">
        <Clock3Icon aria-hidden="true" className="h-4 w-4" data-id="element-3" />
        La oferta actual se renueva en
      </div>
      <div className="flex justify-center gap-2 sm:gap-3" aria-live="polite" data-id="element-4">
        <TimeUnit label="Horas" value={hours} data-id="element-5" />
        <span className="pt-1 text-3xl font-bold text-[#d49a35]" data-id="element-6">:</span>
        <TimeUnit label="Minutos" value={minutes} data-id="element-7" />
        <span className="pt-1 text-3xl font-bold text-[#d49a35]" data-id="element-8">:</span>
        <TimeUnit label="Segundos" value={secs} data-id="element-9" />
      </div>
    </section>;
}
function TimeUnit({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div className="min-w-[64px] text-center" data-id="element-10">
      <span className="block font-serif text-4xl font-bold tabular-nums text-[#fff8e9]" data-id="element-11">
        {value}
      </span>
      <span className="text-[10px] font-bold uppercase tracking-wider text-[#c9b99c]" data-id="element-12">
        {label}
      </span>
    </div>;
}